const dashboard = {
    templateUrl: '/modules/pis-tool/dashboard/dashboard.html',
    controller: 'DashboardController',
};

angular
    .module('pis-tool.module')
    .component('dashboard', dashboard)
    .config(function ($stateProvider) {
        $stateProvider.state('pis', {
            url: '/pis',
            redirectTo: 'pis.workspaces', // Default view to redirect to
            component: 'dashboard',
            resolve: {
                auth: function (userService, $state, eventService) {
                    return userService
                        .resolve(['ACCESS_PIS'])
                        .then(() => {
                        })
                        .catch(() => {
                            eventService.trigger('userservice:unauthorized');
                            $state.go('frontpage');
                        });
                },
            },
        });
    });
